import styled from 'styled-components'

import { SectionFrame } from './Section'

export const Header = styled(SectionFrame).attrs({ as: 'header' })``
